var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientCommunicationBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10347_49103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.334 24.72V33.8067L32.4273 28.9L31.4873 29.84L36.3073 34.6667H19.774L24.4407 29.84L23.4807 28.9133L18.6673 33.8933V22.3467L26.954 30.5933C27.2038 30.8417 27.5417 30.9811 27.894 30.9811C28.2462 30.9811 28.5842 30.8417 28.834 30.5933L34.7206 24.74C34.2509 24.6174 33.8016 24.4265 33.3873 24.1733L27.8807 29.6467L19.5407 21.3333H31.2073C31.0784 20.9003 31.0089 20.4517 31.0007 20H18.6673C18.3137 20 17.9746 20.1405 17.7245 20.3905C17.4745 20.6406 17.334 20.9797 17.334 21.3333V34.6667C17.334 35.0203 17.4745 35.3594 17.7245 35.6095C17.9746 35.8595 18.3137 36 18.6673 36H37.334C37.6876 36 38.0267 35.8595 38.2768 35.6095C38.5268 35.3594 38.6673 35.0203 38.6673 34.6667V24.1333C38.2541 24.3934 37.8048 24.591 37.334 24.72Z",
    fill: "#0F314D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9993 23.24C37.8403 23.24 39.3327 21.7476 39.3327 19.9067C39.3327 18.0657 37.8403 16.5734 35.9993 16.5734C34.1584 16.5734 32.666 18.0657 32.666 19.9067C32.666 21.7476 34.1584 23.24 35.9993 23.24Z",
    fill: "#0F314D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10347_49103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientCommunicationBlue);
export default __webpack_public_path__ + "static/media/clientCommunicationBlue.916ec02cc4ab43e482ea203edb45eaa9.svg";
export { ForwardRef as ReactComponent };